import posthog from "posthog-js";

import { clearAccessToken } from "../../Services/SessionStore";
import { getPostHogKey } from "../runtimeEnv";
import { clearClientAccessibleCookies } from "./clearClientCookies";
import { removeAllLocalStorage, removeAllSessionStorage } from "./LocalStorage";

/** Clear PostHog distinct_id and group associations (multi-tenant safety). */
export const resetPostHogAnalytics = (): void => {
  if (!getPostHogKey()) return;
  posthog.reset();
};

/** Clear all client-side session data (storage, readable cookies, in-memory token). */
export const clearLocalSessionState = (): void => {
  resetPostHogAnalytics();
  clearAccessToken();
  removeAllLocalStorage();
  removeAllSessionStorage();
  clearClientAccessibleCookies();
};
